'use client';
import dynamic from 'next/dynamic';

export default dynamic(() => import('./magnolia-cms-page-metadata.component'));
